import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'lib-cdw-spinner',
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './common-ui-components-spinner.component.html',
  styleUrl: './common-ui-components-spinner.component.scss',
})
export class CommonUiComponentsSpinnerComponent {
  @Input() type: 'apple' | 'material' = 'apple';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() color?: string; // Custom color for the spinner dashes

  get spinnerSize(): number {
    switch (this.size) {
      case 'small':
        return 20;
      case 'medium':
        return 32;
      case 'large':
        return 32;
      default:
        return 32;
    }
  }

  get dashWidth(): number {
    switch (this.size) {
      case 'small':
        return 2;
      case 'medium':
        return 4;
      case 'large':
        return 6;
      default:
        return 4;
    }
  }

  get dashHeight(): number {
    switch (this.size) {
      case 'small':
        return 5;
      case 'medium':
        return 8;
      case 'large':
        return 12;
      default:
        return 8;
    }
  }

  get translateDistance(): number {
    switch (this.size) {
      case 'small':
        return 8;
      case 'medium':
        return 12;
      case 'large':
        return 20;
      default:
        return 12;
    }
  }
}
